// extracted by mini-css-extract-plugin
export default {"toolbar":"ygNwvGMmJhP1wYc46BFH"};